import React, { FC } from 'react'
import { Block, Wrapper, LeftText, RightText } from './styled'

export const FooterComponent: FC = () => (
	<Block>
		<Wrapper>
			<LeftText>
				Реклама. Рекламодатель ПАО Сбербанк. ИНН 7707083893. Расчетно-кассовое обслуживание (далее
				РКО) предоставляет ПАО Сбербанк (далее Банк). Подробную информацию об услуге Вы можете
				получить в отделениях Банка, обслуживающих юридических лиц и индивидуальных
				предпринимателей, по телефону Контактного центра 8-800-555-57-77 (звонки по России —
				бесплатно) или на сайте Банка: http://www.sberbank.ru.
			</LeftText>
			<RightText>
				АО «Деловая среда» (ОГРН: 1127746271355, адрес места нахождения единоличного исполнительного
				органа: 117997, г. Москва, ул. Вавилова, д. 19) входит в группу компаний ПАО Сбербанк и
				выступает агентом Банка на основании агентского договора. Изменение условий производится
				Банком в одностороннем порядке. Информация, представленная в данном материале, не является
				публичной офертой Банка. Генеральная лицензия Банка России № 1481 от 11.08.2015.
			</RightText>
		</Wrapper>
	</Block>
)
